import { render } from "./DataGrid.vue?vue&type=template&id=5177d120&scoped=true"
import script from "./DataGrid.vue?vue&type=script&lang=js"
export * from "./DataGrid.vue?vue&type=script&lang=js"

import "./DataGrid.vue?vue&type=style&index=0&id=5177d120&lang=scss&scoped=true"
import "./DataGrid.vue?vue&type=style&index=1&id=5177d120&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5177d120"]])

export default __exports__